const DriverType = {
	hysys: 'hysys',
	petrosim: 'petrosim',
	ann: 'ann',
	// lummus: 'lummus',
	lummus2: 'lummus2',
	expression: 'expression',
	workflow: 'workflow',
	opc: 'opc',
	spreadsheet: 'spreadsheet'
};

export default DriverType;
